import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "px-[34px] icon flex justify-center mb-4" }
const _hoisted_3 = ["src"]

import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { IonContent, IonIcon, IonSpinner } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { chevronBackOutline } from 'ionicons/icons';

import TopBar from '@/shared/components/TopBar.vue';
import searchUser from '@/modules/guest/composables/useGuestUser';
import { useAssetsStore } from '@/stores/shared/assetsStore';
import GuestWalletBox from '../components/GuestWalletBox.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GuestWalletPage',
  setup(__props) {

const { t } = useI18n();
const assetStore = useAssetsStore();
const router = useRouter();

const route = useRoute();
const loginToken = route.params.id.toString();

const { guestUserProfile, isSuccessGuestProfile, userMutate } = searchUser();

onMounted(async () => {
	userMutate({ login_token: loginToken });
});

const goBack = async () => {
	await router.push({ path: '/dashboard' });
};

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [
          _createVNode(_component_ion_button, {
            class: "w-[35px] h-[35px] text-black ion-no-padding ion-no-margin hover:bg-white hover:rounded-full",
            shape: "round",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                icon: _unref(chevronBackOutline),
                class: "ion-no-padding ion-no-margin text-black mr-[2px]"
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        center: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('guest_top_up.title')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(assetStore).logoUrl,
            class: "max-w-[70%]"
          }, null, 8, _hoisted_3)
        ]),
        _createVNode(GuestWalletBox, {
          "user-profile": _unref(guestUserProfile),
          "is-success-profile": _unref(isSuccessGuestProfile),
          "login-token": _unref(loginToken)
        }, null, 8, ["user-profile", "is-success-profile", "login-token"])
      ])
    ]),
    _: 1
  }))
}
}

})